import React from 'react';

interface InformationOptionLabelProps {
    label: string;
}

function InformationOptionLabel({ label }: InformationOptionLabelProps): React.JSX.Element {
    return (
        <div className="text-foreground min-w-0 flex-1">
            <span className="text-base">{label}</span>
        </div>
    );
}

export default InformationOptionLabel;
